import { render, staticRenderFns } from "./AdminSteamItem.vue?vue&type=template&id=0183f580&scoped=true&"
import script from "./AdminSteamItem.vue?vue&type=script&lang=ts&"
export * from "./AdminSteamItem.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSteamItem.vue?vue&type=style&index=0&id=0183f580&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0183f580",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
